export const sectionTitleSx = {
  color: "#061522",
  fontFamily: "Inter",
  fontSize: 20,
  fontWeight: 500,
  lineHeight: "34px",
  mb: 1.5,
};

export const sectionCardSx = {
  width: "100%",
  maxWidth: 632,
  borderRadius: "8px",
  border: "1px solid #E5E9EC",
  background: "#FFF",
  p: 3,
  boxSizing: "border-box",
};
